import Vue from 'vue'
import App from './App.vue'
import ElementUI from 'element-ui'
import Inner from './layouts/Inner'
import Outer from './layouts/Outer'
import VueI18n from 'vue-i18n'
import MomentJalali from 'vue-jalali-moment'
import Forms from './mixins/Forms'
import Messages from './mixins/Messages'
import Teams from './mixins/Teams'
import Time from './mixins/Time'
import Loading from './mixins/Loading'
import router from './router'
import { store } from './store'
import { messages } from './locale'
import VueClipboard from 'vue-clipboard2'
import * as Sentry from '@sentry/browser'
import * as Integrations from '@sentry/integrations'

Vue.component('default-layout', Inner)
Vue.component('outer-layout', Outer)
Vue.use(MomentJalali)
Vue.use(VueI18n)
Vue.use(VueClipboard)
Vue.mixin(Forms)
Vue.mixin(Messages)
Vue.mixin(Teams)
Vue.mixin(Time)
Vue.mixin(Loading)

const i18n = new VueI18n({
  locale: 'fa',
  messages
})

if (process.env.DEBUG) {
  Sentry.init({
    dsn: process.env.VUE_APP_SENTRY_DSN,
    integrations: [new Integrations.Vue({ Vue, attachProps: true })]
  })
}

Vue.use(ElementUI, {
  i18n: (key, value) => i18n.t(key, value)
})

Vue.config.productionTip = false

localStorage.removeItem('server_access_token')
// End Router interceptors
new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
